var _defs, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroundadvantage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1520,
    height: 516,
    viewBox: "0 0 1520 516",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 360px;\n        fill: #1d2653;\n        text-anchor: middle;\n        font-family: Poppins;\n        font-weight: 700;\n        text-transform: uppercase;\n      }\n    "))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "GROUND_ADVANTAGE",
    "data-name": "GROUND  ADVANTAGE",
    className: "cls-1",
    transform: "translate(758 187.686) scale(0.645)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0
  }, "GROUND "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    dy: 432
  }, "ADVANTAGE"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundadvantage);
export default __webpack_public_path__ + "static/media/groundadvantage.3773657bb400af30f438301cee92880e.svg";
export { ForwardRef as ReactComponent };